import { useMemo } from 'react'
import { useRouterState } from '@tanstack/react-router'
import { useProjects } from '@/lib/db/rxdb/hooks/entities/projects'

/**
 * The project the page you're on belongs to: a project route's project, else
 * a space route's space. Where the global "+" files things by default
 * (design 29a: "defaults to the page you're on").
 */
export function useRouteProjectId(): string | null {
  const pathname = useRouterState({ select: (state) => state.location.pathname })
  const { projects } = useProjects()

  return useMemo(() => {
    const key =
      pathname.match(/\/projects\/([^/]+)/)?.[1] ?? pathname.match(/\/spaces\/([^/]+)/)?.[1]
    if (!key) return null
    const lower = decodeURIComponent(key).toLowerCase()
    return (
      projects.find(
        (project) => !project.isDeleted && project.projectKey.toLowerCase() === lower,
      )?.id ?? null
    )
  }, [pathname, projects])
}
